export const DEFAULT_CANVAS_CONFIG = {
  width: 1000, // 300 * 3.333 - full resolution
  widthShort: 833, // 250 * 3.333 - full resolution
  adjustingHeight: 67, // 20 * 3.333 - full resolution
  fontSize: 47, // 14 * 3.333 - used in the divider (full resolution)
  fontSizeBig: 60, // 18 * 3.333 - used in the normal lang/lang without divider (full resolution)

  fontFamily: 'Futura',
  fontStyleNormal: 'normal',
  fontStyleItalic: 'italic',

  fontFamilyLatinExtended: 'Questrial',
  fontSizeLatinExtended: 60, // 18 * 3.333 - full resolution
  fontStyleLatinExtended: 'bold',

  fontFamilyCyrillic: 'Didact Gothic',
  fontStyleCyrillic: 'bold',
  fontSizeCyrillic: 60, // 18 * 3.333 - full resolution

  textSeparation: 2, // Line height multiplier - keep as is
  separatorHeight: 10, // 3 * 3.333 - full resolution
  padding: { left: 33, right: 33, top: 33, bottom: 33 }, // 10 * 3.333 - full resolution
  separatorPadding: 20, // 6 * 3.333 - full resolution
  alignment: 'left',
  textLengthLimit: 47, // Character count - keep as is
  backgroundColor: '#FFFFFF',
  whiteBoxSize: 1000, // 300 * 3.333 - full resolution (white eraser box)
  // ... other global canvas settings
};
